
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export const useWorkoutPlans = () => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ["workout-plans", user?.id],
    queryFn: async () => {
      if (!user) return [];
      
      console.log("🔍 Fetching workout plans for user:", user.id);

      // Get all plans created by the user (including personal copies)
      const { data: plans, error } = await supabase
        .from("workout_plans")
        .select("id, name, description, is_personal, mode, created_at, copied_from_plan_id, created_by")
        .eq("created_by", user.id)
        .order("created_at", { ascending: false });

      if (error) throw error;

      console.log("✅ Workout plans fetched:", plans?.length || 0, "plans");

      // All plans are now editable by the user since they own them
      return (plans || []).map(plan => ({
        ...plan,
        isSubscribed: !!plan.copied_from_plan_id, // Mark copied plans as "subscribed"
        canEdit: true // All plans are editable since user owns them
      }));
    },
    enabled: !!user,
    staleTime: 30000,
    gcTime: 300000,
    retry: 2,
    retryDelay: 1000,
  });
};
